import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure58 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
marginLeft: 180,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '600px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},

colors: ['#dae3f3', '#5b9bd5'],

credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},

plotOptions: {
series: {
borderWidth: 0,
marker: {
    symbol: 'circle',
    enabled: false,
    states: {
		    hover: {
				   enabled: true,
				   radius: 5
			   }
	    }
}
}
},

exporting: {
enabled: false
},

xAxis: [{
categories: [
	     "Monde",
	     "",
	     "Australie et Nouvelle-Zélande*",
	     "Europe et Amérique du Nord",
	     "Afrique du Nord et Asie de l’Ouest",
	     "Amérique latine et Caraïbes",
	     "Asie de l’Est et Asie du Sud-Est",
	     "Asie centrale et Asie du Sud",
	     "Océanie (à l’exception de l’Australie et de la Nouvelle-Zélande)",
	     "Afrique subsaharienne",
	     "",
	     "Pays en développement sans littoral",
	     "Pays les moins avancés",
	     "Petits pays insulaires en développement",
],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
useHTML: true,
tickLength: 16,
labels: {
   style: {
  textOverflow: 'none',
  fontWeight: 'normal',
  color: '#999999',
  fontSize: '12px'
}
},
}],
yAxis: [{
labels: {
   format: '{value}',
   style: {
		   fontWeight: 'normal',
		   color: '#999999',
		   fontSize: '12px'
	   },
},
max: 5,
min: 0,
tickInterval: 1,
gridLineWidth: 0,
title: {
   text: 'Niveau moyen de mise en œuvre: 1 le plus faible – 5 le plus élevé',
   style: {
		 color: Highcharts.getOptions().colors[1]
	 }
}
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
style: {
   padding: 0
}
},
legend: {
enabled: false,
},

series: [
{
name: '2018',
tooltip: {
 valueSuffix: '%'
},
dataLabels: {
	      enabled: true,
	      format: '{point.label}', // Display the label
 style: {
		  fontWeight: 'normal',
		  textOutline: false,
		  color: '#999999',
		  fontSize: '12px'
	  }
},
data: [
3,
{ y: 0 },
5,
5,
3,
3,
4,
3,
4,
4,
       { y: 0},
       { y: 0, label: 'Non applicable' },
3,
3,
],
},
{
name: '2022',
tooltip: {
 valueSuffix: '%'
},
dataLabels: {
	      enabled: true,
	      format: '{point.label}', // Display the label
 style: {
		  fontWeight: 'normal',
		  textOutline: false,
		  color: '#999999',
		  fontSize: '12px'
	  }
},
data: [
4,
{ y: 0 },
{ y: 0 },
5,
4,
4,
4,
3,
4,
3,
       { y: 0 },
       { y: 0, label: 'Non applicable' },
       3,
       4,
]
}]
}
